
import { defineComponent } from 'vue';
import PaymentSlot from '../components/PaymentSlot.vue';
import authStore from '@/firebase/auth';
import { listProducts } from '@/firebase/cloudFunctions';
import TextBubble from '@/modules/globalModule/components/TextBubble.vue';
import {
  getStripeCheckout,
  getStripeCustomerPortal,
  getStripeCustomerSubscription,
  getSubscriptionQuantity
} from '@/stripe/stripeSubscription';
import Stripe from 'stripe';
export default defineComponent({
  name: 'PaymentsPage',
  components: { PaymentSlot, TextBubble },
  async mounted() {
    console.log(authStore);
    if (!authStore.email || !authStore.stripeId) {
      this.$router.push('/login');
      return;
    }
    await this.getUserSubscription();
  },
  data(): {
    userSubscription: Stripe.Subscription | undefined;
    subscriptionCounter: number;
    stripeExternalLink: undefined | string;
  } {
    return {
      userSubscription: undefined,
      subscriptionCounter: 1,
      stripeExternalLink: undefined
    };
  },
  methods: {
    async getUserSubscription() {
      console.log('getting subscription');
      if (!authStore.stripeId) {
        return;
      }
      this.userSubscription = await getStripeCustomerSubscription(
        authStore.stripeId
      );
      if (this.userSubscription) {
        this.subscriptionCounter = getSubscriptionQuantity(
          this.userSubscription
        );
      }
      console.log(this.userSubscription);
    },
    getSubscriptionButtonTitle() {
      if (this.userSubscription && this.subscriptionCounter === 0)
        return 'Unsubscribe';
      if (
        this.userSubscription &&
        getSubscriptionQuantity(this.userSubscription) !==
          this.subscriptionCounter
      )
        return 'Update';
      if (this.userSubscription) return 'Subscribed';
      return 'Upgrade';
    },
    async onSubscriptionButtonPress() {
      if (!authStore.stripeId) {
        return;
      }
      if (this.userSubscription) {
        this.openCustomerPortal();
      } else
        this.openPaymentLink('Monthly Subscription', this.subscriptionCounter);

      // const buttonTitle = this.getSubscriptionButtonTitle();
      // if (buttonTitle === 'Upgrade') {
      //   await this.openPaymentLink(
      //     'Monthly Subscription',
      //     this.subscriptionCounter
      //   );
      // } else if (buttonTitle === 'Unsubscribe' && this.userSubscription) {
      //   await cancelSubscription({ email: authStore.email || undefined });
      //   await this.getUserSubscription();
      // } else if (buttonTitle === 'Update') {
      // }
    },
    async openPaymentLink(productName: string, quantity: number = 1) {
      console.log('opening payment link');
      if (!authStore.stripeId) {
        this.$router.push('/login');
        return;
      }
      const products = await listProducts();
      if (products.length < 2 || !products[1] || products[0].length === 0) {
        console.warn('No products found');
        return;
      }
      const targetProd = products[0].find((prod: any) => {
        return prod.name === productName;
      });
      if (!targetProd) {
        console.warn(`Warning: no product with name '${productName}' found.`);
        return;
      }
      const checkout = await getStripeCheckout(
        authStore.stripeId,
        targetProd.id,
        quantity
      );
      if (!checkout || !checkout.url) {
        console.warn('Get Stripe Checkout failed');
        return;
      }
      this.stripeExternalLink = checkout.url;
      window.open(checkout.url);
    },
    async openCustomerPortal() {
      if (!authStore.stripeId) {
        return;
      }
      const customerPortal = await getStripeCustomerPortal(authStore.stripeId);
      if (customerPortal) {
        this.stripeExternalLink = customerPortal.url;
        window.open(customerPortal.url);
      }
    },
    getSubscriptionQuantity(subscription: Stripe.Subscription) {
      return getSubscriptionQuantity(subscription);
    }
  }
});
